/* =========================================================================
   lits-storyselling.js
   v2.9 — dynamic CTA-sub aligned to LITS 10% OFF / 15% OFF auto-discounts.
   Skips dynamic message if no multi-qty bundle exists (e.g. gift card).
   v2.9: em-dash removed from customer-facing copy (brand writing rule).
   ========================================================================= */
(function () {
  'use strict';

  function bind(el) {
    if (!el || el.dataset.litsBound === '1') return false;
    el.dataset.litsBound = '1';
    return true;
  }

  function initQtySteppers(root) {
    root.querySelectorAll('[data-lits-qty]').forEach(function (stepper) {
      if (!bind(stepper)) return;
      var display = stepper.querySelector('span');
      var btns = stepper.querySelectorAll('button');
      if (!display || btns.length < 2) return;
      var hiddenInput = stepper.querySelector('input[type="hidden"]');
      var min = parseInt(stepper.getAttribute('data-min') || '1', 10);
      var max = parseInt(stepper.getAttribute('data-max') || '99', 10);
      function setVal(n) {
        n = Math.max(min, Math.min(max, n));
        display.textContent = n;
        if (hiddenInput) hiddenInput.value = n;
        stepper.dispatchEvent(new CustomEvent('lits:qty-change', { detail: { value: n }, bubbles: true }));
      }
      btns[0].addEventListener('click', function (e) { e.preventDefault(); setVal(parseInt(display.textContent, 10) - 1); });
      btns[1].addEventListener('click', function (e) { e.preventDefault(); setVal(parseInt(display.textContent, 10) + 1); });
    });
  }

  function initBundles(root) {
    root.querySelectorAll('[data-lits-bundles]').forEach(function (group) {
      if (!bind(group)) return;
      var opts = group.querySelectorAll('.bundle-opt');
      function fireBundleChange(opt) {
        group.dispatchEvent(new CustomEvent('lits:bundle-change', {
          detail: {
            variantId: opt.getAttribute('data-variant-id'),
            qty: parseInt(opt.getAttribute('data-qty') || '1', 10)
          },
          bubbles: true
        }));
      }
      opts.forEach(function (opt) {
        opt.addEventListener('click', function () {
          opts.forEach(function (o) { o.classList.remove('selected'); });
          opt.classList.add('selected');
          fireBundleChange(opt);
        });
      });
      var selected = group.querySelector('.bundle-opt.selected');
      if (selected) {
        var qty = parseInt(selected.getAttribute('data-qty') || '1', 10);
        var container = group.closest('form') || group.closest('section') || document;
        var stepper = container.querySelector('[data-lits-qty]');
        if (stepper) {
          var display = stepper.querySelector('span');
          if (display) display.textContent = qty;
          var hidden = stepper.querySelector('input[name="quantity"]');
          if (hidden) hidden.value = qty;
        }
        updateCtaSub(qty);
      }
    });
  }

  function initGallery(root) {
    root.querySelectorAll('[data-lits-gallery]').forEach(function (gallery) {
      if (!bind(gallery)) return;
      var mainImg = gallery.querySelector('.gallery-main img');
      var thumbs = gallery.querySelectorAll('.thumb');
      if (!mainImg || !thumbs.length) return;
      thumbs.forEach(function (thumb) {
        thumb.addEventListener('click', function () {
          var fullUrl = thumb.getAttribute('data-full');
          var thumbImg = thumb.querySelector('img');
          if (!fullUrl && thumbImg) fullUrl = thumbImg.getAttribute('src');
          if (!fullUrl) return;
          thumbs.forEach(function (t) { t.classList.remove('active'); });
          thumb.classList.add('active');
          mainImg.src = fullUrl;
        });
      });
    });
  }

  function initStickyShadow() {
    var bars = document.querySelectorAll('.promo, .nav, [data-lits-sticky]');
    if (!bars.length || document.body.dataset.litsStickyBound === '1') return;
    document.body.dataset.litsStickyBound = '1';
    function onScroll() {
      var scrolled = window.scrollY > 4;
      bars.forEach(function (b) { b.classList.toggle('scrolled', scrolled); });
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  function initReveal() {
    if (!('IntersectionObserver' in window)) return;
    var els = document.querySelectorAll('[data-lits-reveal]:not(.is-visible)');
    if (!els.length) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          io.unobserve(entry.target);
        }
      });
    }, { rootMargin: '0px 0px -10% 0px', threshold: 0.05 });
    els.forEach(function (el) { io.observe(el); });
  }

  function initHeatScales(root) {
    root.querySelectorAll('.heat-scale[data-heat]').forEach(function (scale) {
      if (!bind(scale)) return;
      var heat = parseFloat(scale.getAttribute('data-heat'));
      if (isNaN(heat)) return;
      var pct = Math.max(0, Math.min(100, (heat / 10) * 100));
      var marker = scale.querySelector('.heat-marker');
      if (marker) marker.style.left = pct + '%';
    });
  }

  function initMobileMenu() {
    var toggle = document.querySelector('.lits-mobile-toggle');
    var menu = document.getElementById('lits-mobile-menu');
    var backdrop = document.querySelector('[data-lits-mobile-backdrop]');
    if (!toggle || !menu || !backdrop) return;
    if (!bind(toggle)) return;
    function setOpen(open) {
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      menu.classList.toggle('open', open);
      backdrop.classList.toggle('open', open);
      menu.setAttribute('aria-hidden', open ? 'false' : 'true');
      document.body.classList.toggle('lits-menu-open', open);
    }
    toggle.addEventListener('click', function () { setOpen(!menu.classList.contains('open')); });
    backdrop.addEventListener('click', function () { setOpen(false); });
    menu.querySelectorAll('a').forEach(function (a) { a.addEventListener('click', function () { setOpen(false); }); });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && menu.classList.contains('open')) setOpen(false);
    });
  }

  // ---------- Dynamic CTA-sub message ----------
  // Only applies on pages with multi-quantity bundles (3-pack, 6-pack).
  // On gift card / single-qty pages, leaves the static template copy alone.
  function pageHasMultiQtyBundles() {
    var bundles = document.querySelectorAll('[data-lits-bundles] .bundle-opt');
    var hasMulti = false;
    bundles.forEach(function (b) {
      if (parseInt(b.getAttribute('data-qty') || '1', 10) > 1) hasMulti = true;
    });
    return hasMulti;
  }

  function updateCtaSub(qty) {
    if (!pageHasMultiQtyBundles()) return; // Skip on gift card / single-pack pages
    var ctaSub = document.querySelector('.add-cart-sub');
    if (!ctaSub) return;
    qty = parseInt(qty, 10) || 0;
    if (qty < 3) {
      var needed = 3 - qty;
      var word = needed === 1 ? 'bottle' : 'bottles';
      ctaSub.innerHTML = '🌶️ Add <strong>' + needed + '</strong> more ' + word + ' to unlock <strong>10% off</strong>';
    } else if (qty < 6) {
      var moreNeeded = 6 - qty;
      var wordB = moreNeeded === 1 ? 'bottle' : 'bottles';
      ctaSub.innerHTML = '🎉 <strong>10% off</strong> unlocked → add <strong>' + moreNeeded + '</strong> more ' + wordB + ' to save <strong>15%</strong>';
    } else {
      ctaSub.innerHTML = '🎁 <strong>15% off</strong> unlocked + free shipping on <strong>$50+</strong>';
    }
  }

  function initCtaSub() {
    if (document.body.dataset.litsCtaBound === '1') return;
    document.body.dataset.litsCtaBound = '1';
    var ctaSub = document.querySelector('.add-cart-sub');
    if (!ctaSub) return;
    if (!pageHasMultiQtyBundles()) return; // Static copy stays on gift card pages
    var stepper = document.querySelector('[data-lits-qty]');
    if (stepper) {
      var display = stepper.querySelector('span');
      if (display) updateCtaSub(parseInt(display.textContent, 10) || 1);
    }
    document.addEventListener('lits:qty-change', function (e) {
      if (e.detail) updateCtaSub(e.detail.value);
    });
    document.addEventListener('lits:bundle-change', function (e) {
      if (e.detail && e.detail.qty) updateCtaSub(e.detail.qty);
    });
  }

  function initAll(root) {
    root = root || document;
    initQtySteppers(root);
    initBundles(root);
    initGallery(root);
    initHeatScales(root);
  }
  function bootstrap() {
    initAll();
    initStickyShadow();
    initReveal();
    initMobileMenu();
    initCtaSub();
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootstrap);
  } else {
    bootstrap();
  }
  document.addEventListener('shopify:section:load', function (e) {
    initAll(e.target);
    initMobileMenu();
  });
  window.LITS = window.LITS || {};
  window.LITS.init = initAll;
  window.LITS.initMobileMenu = initMobileMenu;
  window.LITS.updateCtaSub = updateCtaSub;
})();
